// import function to register Swiper custom elements
import { register } from 'swiper/element/bundle'

register()
